import PropTypes from "prop-types";
import React, { Component } from "react";

import classNames from "classnames";

class ContentSwitcherElement extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    button_text: PropTypes.string.isRequired,
    visible: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.body_content = this.props.children;
  }

  render() {
    return (
      <div
        className={
          classNames({
            "content-switcher-element": true,
            "--visible": this.props.visible,
          })
        }
      >
        { this.body_content }
      </div>
    );
  }
}

export default ContentSwitcherElement;
